export default [
  {
    path: '/platform',
    name: 'platform',
    component: () => import('@/views/platform/index'),
    meta: {
      loginNo: true
    }
  },
  {
    path: '/login',
    name: 'LOGIN',
    component: () => import('@/views/login'),
    meta: {
      title: '登录',
      loginNo: true
    }
  },
  {
    path: '/authentication',
    name: 'AUTHENTICATION',
    component: () => import('@/views/authentication'),
    meta: {
      title: '实名认证'
    }
  },
  {
    path: '/addressList',
    name: 'ADDRESSLIST',
    component: () => import('@/views/addressList'),
    meta: {
      title: '地址管理'
    }
  },
  {
    path: '/addressEdit/:id?',
    name: 'ADDRESSEDIT',
    component: () => import('@/views/addressEdit'),
    meta: {
      title: '地址'
    }
  },
  {
    path: '/agreement/index/:id',
    name: 'agreement-index',
    component: () => import('@/views/agreement/index'),
    meta: {
      loginNo: true
    }
  },
  {
    path: '/agreement', // 微医
    name: 'AGREEMENT',
    component: () => import('@/views/agreement/contents'),
    meta: {
      title: '协议政策',
      loginNo: true
    }
  },
  {
    path: '/agreement/protocol',
    name: 'PROTOCOL',
    component: () => import('@/views/agreement/protocol'),
    meta: {
      title: '微医用户注册及服务协议',
      loginNo: true
    }
  },
  {
    path: '/agreement/privacy',
    name: 'PRIVACY',
    component: () => import('@/views/agreement/privacy'),
    meta: {
      title: '隐私权政策',
      loginNo: true
    }
  },
  {
    path: '/ydHealth/agreement', // 一敦健康 使用
    name: 'YDAGREEMENT',
    component: () => import('@/views/agreement/ydHealth/contents'),
    meta: {
      title: '协议政策',
      loginNo: true
    }
  },
  {
    path: '/ydHealth/agreement/protocol',
    name: 'YDPROTOCOL',
    component: () => import('@/views/agreement/ydHealth/protocol'),
    meta: {
      title: '一敦健康用户注册及服务协议',
      loginNo: true
    }
  },
  {
    path: '/ydHealth/agreement/privacy',
    name: 'YDPRIVACY',
    component: () => import('@/views/agreement/ydHealth/privacy'),
    meta: {
      title: '隐私权政策',
      loginNo: true
    }
  },
  {
    path: '/guahao/agreement/protocol', // 挂号网 大屏 使用
    name: 'GUAHAOPROTOCOL',
    component: () => import('@/views/agreement/guahao/protocol'),
    meta: {
      title: '挂号网在线法律声明',
      loginNo: true
    }
  },
  {
    path: '/guahao/agreement/privacy',
    name: 'GUAHAOPRIVACY',
    component: () => import('@/views/agreement/guahao/privacy'),
    meta: {
      title: '挂号网在线隐私权政策',
      loginNo: true
    }
  },
  {
    path: '/guahao/agreement/register',
    name: 'GUAHAOREGISTER',
    component: () => import('@/views/agreement/guahao/register'),
    meta: {
      title: '挂号网在线用户注册及服务协议',
      loginNo: true
    }
  },
  {
    path: '/gdzlyx/agreement',
    name: 'GDZLYXAGREEMENT',
    component: () => import('@/views/gdzlyx/agreement'),
    meta: {
      title: '移动粤享健康第三方服务协议V3',
      loginNo: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/common.js